import Google from "../../../Assets/Google.webp"
import Kfc from "../../../Assets/kfc.webp"
import Wilson from "../../../Assets/wilson.webp"
import ATT from "../../../Assets/at&t.webp"
import Patagonia from "../../../Assets/patagonia.webp"

const result = [
    {
        Name: "Google",
        Icon: Google,
        IconSize: "120px",
        Text: "Our embedded partnership with Google is as deep as it gets. We're the lead creative agency for Google Store and provide strategy, design, and prototyping to other divisions. Learn more about our partnership ",
        Link: true
    },
    {
        Name: "Kfc",
        Icon: Kfc,
        IconSize: "120px",
        Text: "An award-winning global, digital transformation engagement spanning eCommerce, mobile app, and new drive thru experiences. Bringing KFC's brand story to life while making it easier for customers to buy chicken. Learn more about our partnership ",
        Link: true
    },
    {
        Name: "Wilson",
        Icon: Wilson,
        IconSize: "160px",
        Text: "A reimagining of Wilson's brand visual identity, and brand campaign, to support a new product drop and the launch of the first brick and mortar retail location in the brand's 108-year history. Read our full case study ",
        Link: true
    },
    {
        Name: "AT&T",
        Icon: ATT,
        IconSize: "40px",
        Text: "Redesigning the digital flagship for the largest telecommunications company in the world. Creating frictionless paths to purchase for a wide range of consumers across a vast portfolio of products and services."
    },
    {
        Name: "Patagonia",
        Icon: Patagonia,
        IconSize: "200px",
        Text: "Ongoing partnership providing strategy, branding, experience design, and development focused on bringing their mission and offerings to consumers through brand-led programs and platforms. Read our full case study ",
        Link: true
    },
]

export default result